<div class="container">




  <div fxLayout="column" fxLayoutAlign="space-around center">

    <mat-toolbar fxLayout="row" fxLayoutAlign="space-around center" style="background-color: white;height: 100px">


      <img fxFlex="20" src="assets/MSGI.jpg" />
      <h1 fxFlex="60" class="title"
        style="text-align: center; font-size: 50px;font-family: fantasy, Helvetica, sans-serif;">Suivi De Production -
        {{ Machine_Code | uppercase }}</h1>
      <p fxFlex="20" class="title" style="text-align: center;"> {{dateAujourdhui}}</p>

    </mat-toolbar>


    <h1 style="text-align: start;color: #0d47a1;">Bonjour {{connectedEmployees}}</h1>


    <div class="w-100" fxLayout="row" fxLayoutAlign="space-around start">


      <div fxFlex="48">
        <div fxLayout="column" fxLayoutAlign="center center">


          <h2 style="color: #0d47a1;">Avancement journalier</h2>
          <!-- <app-table  [source]="sourceRendementQuotidientMachine" #tableRendementQuotidientMachine></app-table> -->
          <table class="w-100 mat-elevation-z8" #tableJournalier mat-table [dataSource]="dataSourceDaily">

            <ng-container matColumnDef="Operateur">
              <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef> Operateur </th>
              <td class="font-size-12" mat-cell *matCellDef="let element"> {{element.Perso}}</td>
            </ng-container>

            <ng-container matColumnDef="OF">
              <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef> OF </th>
              <td class="font-size-12" mat-cell *matCellDef="let element"> {{element.OF_Num}} </td>
            </ng-container>

            <ng-container matColumnDef="Designation">
              <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef> Designation </th>
              <td class="font-size-12" mat-cell *matCellDef="let element"> {{element.Art_Car5}} </td>
            </ng-container>

            <ng-container matColumnDef="Avancement">
              <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef> Avancement </th>
              <td class="font-size-12" mat-cell *matCellDef="let element"> {{element.Realise}} / {{element.objectif}}
              </td>
            </ng-container>

            <ng-container matColumnDef="Objectif DJ">
              <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef> Objectif DJ </th>
              <td class="font-size-12" mat-cell *matCellDef="let element">{{element.objectifDJ}}
              </td>
            </ng-container>

            <ng-container matColumnDef="Prix">
              <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef> Prix </th>
              <td class="font-size-12" mat-cell *matCellDef="let element"> {{element.prixU_actualise | number: '1.2-2' }} </td>
            </ng-container>

            <ng-container matColumnDef="Gain">
              <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef> Gain </th>
              <td class="font-size-12" mat-cell *matCellDef="let element"> {{element.gain | number: '1.2-2' }} </td>
            </ng-container>


            <tr class="bg-color h-50" mat-header-row *matHeaderRowDef="displayedColumns2"></tr>
            <tr mat-row [ngClass]="{'bg-green': row.PerformanceMatinExtra }" *matRowDef="let row; columns: displayedColumns2;"></tr>
          </table>

        </div>

      </div>


      <div fxFlex="48">

        <h2 style="text-align: center;color: #0d47a1;">Rendement de Prime de l'opérateur Idéal</h2>

        <table class=" w-100 mat-elevation-z8" #tableMensuel mat-table [dataSource]="dataSource">

          <ng-container matColumnDef="Operateur">
            <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef> Operateur </th>
            <td class="font-size-12" mat-cell *matCellDef="let element"> {{element.Perso_Prenom}} {{element.Perso_Nom}}
            </td>
          </ng-container>

          <ng-container matColumnDef="Gain">
            <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef> Gain/mois </th>
            <td class="font-size-12" mat-cell *matCellDef="let element"> {{element.Gain}} </td>
          </ng-container>

          <ng-container matColumnDef="NbPoteaux">
            <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef> Nb Poteaux </th>
            <td class="font-size-12" mat-cell *matCellDef="let element"> {{element.TotalPieces}} </td>
          </ng-container>

          <ng-container matColumnDef="TonageMensuel">
            <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef> TM </th>
            <td class="font-size-12" mat-cell *matCellDef="let element"> {{element.TotalWeight}} </td>
          </ng-container>

          <ng-container matColumnDef="Score">
            <th class="font-size-18 color-white" mat-header-cell *matHeaderCellDef> Score </th>
            <td class="font-size-12" mat-cell *matCellDef="let element"> {{element.Score}} </td>
          </ng-container>

          <tr class="bg-color h-50" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

      </div>


    </div>


    <h2 style="padding-top: 20px; color: #0d47a1;">Planification des OF</h2>

    <div style="padding-bottom: 10px; font-size: 14px" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="20px">
      <span class="bg-red" style="width: 30px; height: 30px;"></span> 
      <a>En retard</a>
      <span class="bg-orange" style="width: 30px; height: 30px;"></span> 
      <a>Dans moins de 2 jours</a>
      <span class="bg-blue" style="width: 30px; height: 30px;"></span> 
      <a>Dans moins de 4 jours </a>
      <span class="bg-green" style="width: 30px; height: 30px;"></span> 
      <a>Dans plus de 4 jours </a>
    </div>

    <div class="w-100" style="padding: 10px;" fxLayout="row wrap">
      <div *ngFor="let item of OFDGP" style="min-width: 200px;" class="card" fxFlex="10" [ngClass]="
      { 
        'bg-green' : item.DaysLeft > 4 ,  
        'bg-blue' :  item.DaysLeft > 2 , 
        'bg-orange' : item.DaysLeft > 0,
        'bg-red' : item.DaysLeft < 0 
         }">
        <div fxLayout="column">
          <b>{{item.OF_Num}}</b>
          {{item.OFDG_OpeQ}} / {{item.OFDGP_Q}}  ( -{{item.Rec}} ) 
          <br />
          {{item. operateurs }} 
        </div>
      </div>
    </div>




    <div *ngIf="msg" style="position:absolute; display: table-cell; bottom: 0px; width: 100%; padding: 15px; background-color: red; color: white; font-size: 22px; text-align: center; vertical-align: middle;">
      {{msg}}
    </div>


  </div>


  <br>
  <br>






</div>